<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";

	export let caseData = [];
	export let changeFetchParams = () => {};

	let sortDirection = 1;

	function navigateToDetails(vehicleId) {
		navigate(`/issues/case-management/quotation/${vehicleId}`);
	}

	// let data = [
	// 	{
	// 		id: 0,
	// 		caseNo: "CASE-2025-0001",
	// 		photoSubmittedOn: "2025-01-13T03:11:50.522Z",
	// 		bookingNo: "BK-10001",
	// 		vehicleId: 101,
	// 		plateNo: "ABC1234",
	// 		assetOwner: "John Doe",
	// 		investigator: "Alice Smith",
	// 		createdAt: "2025-01-13T03:11:50.522Z",
	// 		status: 2,
	// 	},
	// 	{
	// 		id: 1,
	// 		caseNo: "CASE-2025-0002",
	// 		photoSubmittedOn: "2025-02-01T10:15:22.100Z",
	// 		bookingNo: "BK-10002",
	// 		vehicleId: 102,
	// 		plateNo: "XYZ5678",
	// 		assetOwner: "Jane Miller",
	// 		investigator: "Bob Johnson",
	// 		createdAt: "2025-02-01T10:15:22.100Z",
	// 		status: 1,
	// 	},
	// 	{
	// 		id: 2,
	// 		caseNo: "CASE-2025-0003",
	// 		photoSubmittedOn: "2025-03-05T08:00:00.000Z",
	// 		bookingNo: "BK-10003",
	// 		vehicleId: 103,
	// 		plateNo: "LMN2468",
	// 		assetOwner: "Acme Corp",
	// 		investigator: "Clara Lee",
	// 		createdAt: "2025-03-05T08:00:00.000Z",
	// 		status: 0,
	// 	},
	// ];

	function toggleSort() {
		if (sortDirection === 1) {
			sortDirection = 0;
		} else {
			sortDirection = 1;
		}
		changeFetchParams({ sortDir: sortDirection });
	}
</script>

<CustomTable
	columns={[
		{ key: "caseNo", label: "Case No." },
		{ label: "Vehicle No", key: "plateNo", type: "link" },
		{ label: "Asset Owner", key: "carAssetOwners", type: "masterdata" },
		{ label: "Investigator", key: "investigator" },
		{
			label: "Case Created",
			key: "createdAt",
			type: "date",
			sortCol: 1,
			event: toggleSort,
		},
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "edit",
		},
	]}
	rows={caseData}
	emptyMessage="There are currently no cases to display."
/>
